import { Component, OnInit } from '@angular/core';
import { BaseLoginComponent } from 'src/app/shared/components/base-login/base-login.component';
import {
  errorDescriptionsMap,
  getOptionsFromRedirectUri,
} from 'src/app/shared/utils';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-lasuite-login',
  templateUrl: './lasuite-login.component.html',
  styleUrls: ['../style/global.css', './lasuite-login.component.css'],
})
export class LasuiteLoginComponent
  extends BaseLoginComponent
  implements OnInit
{
  async init(): Promise<void> {}

  /** パスワード変更がされているか否かのフラグを格納する */
  private isNotPasswordChangedUser = false;

  get isMedicalUser() {
    return this.role !== 'patient';
  }

  get isOem() {
    return /oem/g.test(environment.apps[this.clientId].type);
  }

  get isRegisterResendable(): boolean {
    // EAJの場合は確認メール再送信させない
    if (environment.apps[this.clientId].oemConfig?.id === 'EAJ') return false;

    return true;
  }

  get isRegistable() {
    // 医療ユーザーがログインしようとしている場合は新規会員登録させない
    if (this.isMedicalUser) return false;

    // 自治体向けOEMの場合も新規会員登録させない
    if (this.isOem) return false;

    return true;
  }

  get logoUrl() {
    return (
      environment.apps[this.clientId].oemConfig?.imgpath ||
      '/assets/lasuite/images/logo.svg'
    );
  }

  /** ログイン処理をラップして、パスワード変更済みユーザであるか否かを取得する */
  login(params?: { clientId: string; redirectUri: string }): void {
    // /p/l/pu はlasuite password updateの略. S3の該当バケットにファイルを直接アップする
    fetch(`/assets/p/l/pu/${encodeURIComponent(this.email)}`)
      .then(async (e) => {
        // trueで返ったユーザはパスワード未変更ユーザなのでフラグをtrueにする
        this.isNotPasswordChangedUser = (await e.text()) === 'true';
      })
      .finally(() => {
        return super.login(params);
      });
  }

  get customLoginErrorMessage() {
    // 有効期間は2025/08/31まで
    // https://doctors-jp.backlog.com/view/DXUT-203#comment-496633542
    if (new Date() > new Date('2025-08-31T15:00:00.000Z')) {
      return undefined;
    }
    // environmentsに汎用機能を用意したが、要件複雑となった為個別のコンポーネントで実装
    if (!this.isNotPasswordChangedUser) {
      return 'Eメールアドレス、パスワードに誤りがあります。';
    }
    return `システムメンテナンスにより、パスワードの再設定が必要となります。下部の「パスワード再設定」から再設定をお願いします。`;
  }

  protected get errorDescripitionsMap() {
    // ログイン時のエラーメッセージをカスタマイズする
    return {
      'Wrong email or password.':
        this.customLoginErrorMessage ||
        errorDescriptionsMap['Wrong email or password.'],
      'Missing credentials': errorDescriptionsMap['Missing credentials'],
      "Your account has been blocked after multiple consecutive login attempts. We've sent you an email with instructions on how to unblock it.":
        errorDescriptionsMap[
          "Your account has been blocked after multiple consecutive login attempts. We've sent you an email with instructions on how to unblock it."
        ],
      "Your account has been blocked after multiple consecutive login attempts. We've sent you a notification via your preferred contact method with instructions on how to unblock it.":
        errorDescriptionsMap[
          "Your account has been blocked after multiple consecutive login attempts. We've sent you a notification via your preferred contact method with instructions on how to unblock it."
        ],
    };
  }

  /**
   * @link https://doctors-jp.backlog.com/view/DXUT-222
   */
  get isSessionExpired() {
    const parsed = getOptionsFromRedirectUri(this.redirectUri);
    console.log(parsed);

    return parsed.isSessionExpired;
  }
}
